import api from './api';

export const getCategories = async (params) => {
  const response = await api.get('/auth/category', { params });
  return response.data;
};

export const getCategory = async (id) => {
  const response = await api.get(`/auth/category/${id}`);
  return response.data;
};

export const createCategory = async (data) => {
  const response = await api.post('/auth/category', data);
  return response.data;
};

export const updateCategory = async (data) => {
  const response = await api.put('/auth/category', data);
  return response.data;
};

export const deleteCategory = async (id) => {
  const response = await api.delete(`/auth/category/${id}`);
  return response.data;
};
